// posenet code, takes in video feed and returns pose
// also records video feed
import Posenet from "./Posenet";

export default Posenet;
